var findExerciseLocationMap = {
    mapElement: document.getElementById('map'),
    facilityError: document.getElementById('facility-error'),
    map: null,
    markers: [],
    initialMapState: { center: null, zoom: null },
    hasResetToInitialState: false,
    originalListItems: [],
    mapViewButton: document.getElementById('map-view-btn'),
    savedInputValue: null,
    clusterArray: null,

    //Needed for map to finish loading whilst searching on ListView -- cant find a better solution
    disableButtonDuringLoading() {
        if (this.mapViewButton) {
            const mapIcon = this.mapViewButton.querySelector('#map-icon');
            const loadingSpinner = this.mapViewButton.querySelector('#loading-spinner');

            this.mapViewButton.disabled = true;

            // Show spinner and hide icon
            loadingSpinner.style.display = "block";
            mapIcon.style.display = "none";

            // Re-enable button and toggle icon back after loading
            setTimeout(() => {
                this.mapViewButton.disabled = false;
                loadingSpinner.style.display = "none";
                mapIcon.style.display = "block";
            }, 3000);
        } else {
            console.error("mapViewButton not found");
        }
    },
    showPosition = async (position) => {
        await loadGoogleMaps();
        if (typeof google === "undefined" || !google.maps) {
            console.error("Google Maps is not available yet.");
            return;
        }

        if (position && position.coords) {
            const lat = parseFloat(position.coords.latitude);
            const lng = parseFloat(position.coords.longitude);

            await initializeMap(null, 10, lat, lng);

        } else {
            const center = getDefaultCenterByLanguage();

            let latLng = new google.maps.LatLng(center.lat, center.lng);
            await initializeMap(latLng, 6);
        }
    },
    showError = (error) => {
        console.error('Geolocation error:', error);
        findExerciseLocationMap.showPosition(null);
    },
    initMapSetup = async () => {
        await loadGoogleMaps();

        if (typeof google === "undefined" || !google.maps) {
            console.error("❌ Google Maps is not available yet.");
            return;
        }

        if (findExerciseLocationMap.mapElement) {
         
            navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
                if (permissionStatus.state === 'granted') {
                    navigator.geolocation.getCurrentPosition(
                        findExerciseLocationMap.showPosition,
                        findExerciseLocationMap.showError
                    );
                } else {
                    findExerciseLocationMap.showPosition(null);
                }
            }).catch(error => {
                console.error('Error checking geolocation permission:', error);
                findExerciseLocationMap.showPosition(null);
            });
        }
    }
}
